import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { withResolvers } from '@cian/core/utils/shared/promise.js';
import { HttpCancelError } from '@cian/peperrors';

/**
 * Интерфейс отмены запросов
 *
 * @export
 * @interface ICancellationToken
 * @extends {AbortController}
 */

/**
 * Релизация {@linkcode ICancellationToken}
 *
 * @export
 * @class CancellationToken
 * @extends {AbortController}
 * @implements {ICancellationToken}
 */
export var CancellationToken = /*#__PURE__*/function (_AbortController) {
  function CancellationToken() {
    var _this;
    _classCallCheck(this, CancellationToken);
    _this = _callSuper(this, CancellationToken);
    _defineProperty(_this, "promise", void 0);
    _defineProperty(_this, "resolve", void 0);
    var _withResolvers = withResolvers(),
      promise = _withResolvers.promise,
      resolve = _withResolvers.resolve;
    _this.promise = promise;
    _this.resolve = resolve;
    return _this;
  }
  _inherits(CancellationToken, _AbortController);
  return _createClass(CancellationToken, [{
    key: "isCanceled",
    value: function isCanceled() {
      return this.signal.aborted;
    }
  }, {
    key: "cancel",
    value: function cancel(error) {
      if (this.signal.aborted) {
        return;
      }
      var err = error || new HttpCancelError('Canceled HTTP Request', 'http-api.CancellationToken');
      this.abort();
      this.resolve(err);
    }
  }, {
    key: "toPromise",
    value: function toPromise() {
      return this.promise;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.isCanceled()) {
        return;
      }
      this.resolve();
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(AbortController));